// extracted by mini-css-extract-plugin
export default {"container":"connectUs_container__zFLDW","section":"connectUs_section__C4J5y","box1":"connectUs_box1__druCr","icons1":"connectUs_icons1__xTbCR","heading":"connectUs_heading__yPk02"};